import React, { useCallback, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { batch, useDispatch } from 'react-redux';

import { resetFilters, resetSbatGroupBulkUpdate } from 'features/classCreation';
import Field from 'components/Field';
import SectionHeading from 'components/SectionHeading';
import styles from './SelectBatchPage.module.scss';
import SuperBatchSelect from 'components/SuperBatchSelect';

export default function SelectBatchPage() {
  const dispatch = useDispatch();
  const [superBatch, setSuperBatch] = useState();
  const navigate = useNavigate();

  const handleSuperBatchChange = useCallback(
    (option) => {
      setSuperBatch(option);
      navigate(String(option.value));

      batch(() => {
        dispatch(resetSbatGroupBulkUpdate());
        dispatch(resetFilters());
      });
    },
    [dispatch, navigate]
  );

  return (
    <div>
      <SectionHeading title="VIEW SCHEDULE" />
      <Field label="Search Batch">
        <SuperBatchSelect
          className={styles.select}
          value={superBatch}
          onChange={handleSuperBatchChange}
        />
        <div className="disabled h5 m-t-xxs">
          Note: If the selected batch is merged with other batches, all of them
          will be considered as a single unit while rescheduling until they
          diverge
        </div>
      </Field>
      <Outlet />
    </div>
  );
}
